export default "__VITE_ASSET__e538ef84__"